module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_8004.a71ebc39.png";